import React from "react";
import { StyleSheet, Text, View } from "react-native";

const Privacy = () => {
  return (
    <View>
      <Text style={{ fontWeight: "bold", fontSize: 30 }}>PRIVACY NOTICE</Text>
      <Text style={{ fontWeight: 500, fontSize: 12, paddingBottom: 12 }}>
        Last updated December 05, 2021
      </Text>
      <MainText />
      <Text style={styles.paragraph}></Text>
    </View>
  );
};

export default Privacy;

const styles = StyleSheet.create({
  paragraph: {
    fontSize: 14,
    // textAlign: "center",
  },
});

const MainText = () => {
  return (
    <View>
      <Text style={styles.paragraph}>
        Thank you for choosing to be part of our community at online shops
        ("Company," "we," "us," or "our"). We are committed to protecting your
        personal information and your right to privacy. If you have any
        questions or concerns about this privacy notice or our practices with
        regard to your personal information, please contact us at
        smcmblvme@gmail.com.{"\n"}
        {"\n"}
        This privacy notice describes how we might use your information if you:
        {"\n"}• Download and use our mobile application — Online Shops Nigeria
        {"\n"}• Engage with us in other related ways ― including any sales,
        marketing, or events {"\n"}
        {"\n"}In this privacy notice, if we refer to:{"\n"}
        "App," we are referring to any application of ours that references or
        links to this policy, including any listed above {"\n"}"Services," we
        are referring to our App, and other related services, including any
        sales, marketing, or events{"\n"}
        {"\n"} The purpose of this privacy notice is to explain to you in the
        clearest way possible what information we collect, how we use it, and
        what rights you have in relation to it. If there are any terms in this
        privacy notice that you do not agree with, please discontinue use of our
        Services immediately.{"\n"}
        {"\n"} Please read this privacy notice carefully, as it will help you
        understand what we do with the information that we collect.{"\n"}
        {"\n"} TABLE OF CONTENTS{"\n"}
        {"\n"} 1. WHAT INFORMATION DO WE COLLECT?{"\n"} 2. WILL YOUR INFORMATION
        BE SHARED WITH ANYONE?{"\n"} 3. WHAT IS OUR STANCE ON THIRD-PARTY
        WEBSITES?{"\n"} 4. HOW LONG DO WE KEEP YOUR INFORMATION?{"\n"} 5. WHAT
        ARE YOUR PRIVACY RIGHTS?
        {"\n"} 6. CONTROLS FOR DO-NOT-TRACK FEATURES{"\n"} 7. DO CALIFORNIA
        RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?{"\n"} 8. DO WE MAKE UPDATES TO
        THIS NOTICE?{"\n"} 9. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? {"\n"}
        10. HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?{" "}
        {"\n"}
        {"\n"}
        {"\n"}1. WHAT INFORMATION DO WE COLLECT?{"\n"}
        {"\n"}Personal information you disclose to us In Short: We collect
        personal information that you provide to us. We collect personal
        information that you voluntarily provide to us when you express an
        interest in obtaining information about us or our products and Services,
        when you participate in activities on the App or otherwise when you
        contact us.{"\n"}
        The personal information that we collect depends on the context of your
        interactionswith us and the App , the choices you make and the products
        and features you use.The personal information we collect may include the
        following: All personal information that you provide to us must be true,
        complete and accurate,and you must notify us of any changes to such
        personal information. {"\n"}
        {"\n"}2. WILL YOUR INFORMATION BE SHARED WITHANYONE?{"\n"}
        {"\n"} In Short: We only share information with your consent, to comply
        with laws, toprovide you with services, to protect your rights, or to
        fulfill business obligations. We may process or share your data that we
        hold based on the following legal basis: Consent: We may process your
        data if you have given us specific consent touse your personal
        information for a specific purpose. Legitimate Interests: We may process
        your data when it is reasonablynecessary to achieve our legitimate
        business interests. Performance of a Contract: Where we have entered
        into a contract with you,we may process your personal information to
        fulfill the terms of our contract. Legal Obligations: We may disclose
        your information where we are legallyrequired to do so in order to
        comply with applicable law, governmentalrequests, a judicial proceeding,
        court order, or legal process, such as inresponse to a court order or a
        subpoena (including in response to publicauthorities to meet national
        security or law enforcement requirements). Vital Interests: We may
        disclose your information where we believe it isnecessary to
        investigate, prevent, or take action regarding potential violationsof
        our policies, suspected fraud, situations involving potential threats to
        thesafety of any person and illegal activities, or as evidence in
        litigation in whichwe are involved. More specifically, we may need to
        process your data or share your personalinformation in the following
        situations: Business Transfers. We may share or transfer your
        information in connectionwith, or during negotiations of, any merger,
        sale of company assets, financing,or acquisition of all or a portion of
        our business to another company.{"\n"}
        {"\n"} 3. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?{"\n"}
        {"\n"} In Short: We are not responsible for the safety of any
        information that you sharewith third-party providers who advertise, but
        are not affiliated with, our Website. The App may contain advertisements
        from third parties that are not affiliated with usand which may link to
        other websites, online services or mobile applications. Wecannot
        guarantee the safety and privacy of data you provide to any third
        parties. Anydata collected by third parties is not covered by this
        privacy notice. We are notresponsible for the content or privacy and
        security practices and policies of any thirdparties, including other
        websites, services or applications that may be linked to orfrom the App
        . You should review the policies of such third parties and contact
        themdirectly to respond to your questions.
        {"\n"}
        {"\n"}4. HOW LONG DO WE KEEP YOUR INFORMATION?{"\n"}
        {"\n"} In Short: We keep your information for as long as necessary to
        fulfill the purposesoutlined in this privacy notice unless otherwise
        required by law. We will only keep your personal information for as long
        as it is necessary for thepurposes set out in this privacy notice,
        unless a longer retention period is required orpermitted by law (such as
        tax, accounting or other legal requirements). No purpose inthis notice
        will require us keeping your personal information for longer than 90
        days . When we have no ongoing legitimate business need to process your
        personalinformation, we will either delete or anonymize such
        information, or, if this is notpossible (for example, because your
        personal information has been stored in backuparchives), then we will
        securely store your personal information and isolate it fromany further
        processing until deletion is possible.
        {"\n"}
        {"\n"}
        5. WHAT ARE YOUR PRIVACY RIGHTS?{"\n"}
        {"\n"} In Short: You may review, change, or terminate your account at
        any time. If you are a resident in the EEA or UK and you believe we are
        unlawfully processingyour personal information, you also have the right
        to complain to your local dataprotection supervisory authority. You can
        find their contact details here:
        https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
        . If you are a resident in Switzerland, the contact details for the data
        protectionauthorities are available here:
        https://www.edoeb.admin.ch/edoeb/en/home.html . 6. CONTROLS FOR
        DO-NOT-TRACK FEATURES Most web browsers and some mobile operating
        systems and mobile applicationsinclude a Do-Not-Track ("DNT") feature or
        setting you can activate to signal yourprivacy preference not to have
        data about your online browsing activities monitoredand collected. At
        this stage no uniform technology standard for recognizing
        andimplementing DNT signals has been finalized. As such, we do not
        currently respondto DNT browser signals or any other mechanism that
        automatically communicatesyour choice not to be tracked online. If a
        standard for online tracking is adopted thatwe must follow in the
        future, we will inform you about that practice in a revisedversion of
        this privacy notice. {"\n"}
        {"\n"}7. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACYRIGHTS? {"\n"}
        {"\n"}In Short: Yes, if you are a resident of California, you are
        granted specific rightsregarding access to your personal information.
        California Civil Code Section 1798.83, also known as the "Shine The
        Light" law,permits our users who are California residents to request and
        obtain from us, once ayear and free of charge, information about
        categories of personal information (if any)we disclosed to third parties
        for direct marketing purposes and the names andaddresses of all third
        parties with which we shared personal information in theimmediately
        preceding calendar year. If you are a California resident and would
        liketo make such a request, please submit your request in writing to us
        using the contactinformation provided below. If you are under 18 years
        of age, reside in California, and have a registered accountwith the App
        , you have the right to request removal of unwanted data that
        youpublicly post on the App . To request removal of such data, please
        contact us usingthe contact information provided below, and include the
        email address associatedwith your account and a statement that you
        reside in California. We will make surethe data is not publicly
        displayed on the App , but please be aware that the data maynot be
        completely or comprehensively removed from all our systems (e.g.
        backups,etc.).{"\n"}
        {"\n"} 8. DO WE MAKE UPDATES TO THIS NOTICE?{"\n"}
        {"\n"} In Short: Yes, we will update this notice as necessary to stay
        compliant withrelevant laws. We may update this privacy notice from time
        to time. The updated version will beindicated by an updated "Revised"
        date and the updated version will be effective assoon as it is
        accessible. If we make material changes to this privacy notice, we
        maynotify you either by prominently posting a notice of such changes or
        by directlysending you a notification. We encourage you to review this
        privacy notice frequentlyto be informed of how we are protecting your
        information.
        {"\n"}
        {"\n"}
        9. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?{"\n"}
        {"\n"} If you have questions or comments about this notice, you may
        email us at smcmblvme@gmail.com or by post to:Cape Town , Western Cape
        7441 South Africa{"\n"}
        {"\n"} 10. HOW CAN YOU REVIEW, UPDATE, OR DELETE THEDATA WE COLLECT FROM
        YOU?{"\n"}
        {"\n"} Based on the applicable laws of your country, you may have the
        right to requestaccess to the personal information we collect from you,
        change that information, ordelete it in some circumstances.{"\n"}
        {"\n"}
        {"\n"}
      </Text>
    </View>
  );
};
